// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__VoGLK","main-content":"Layout_main-content__I2der","nav-hide":"Layout_nav-hide__wRVMd"};